<script>
    export let value;
</script> 

<div class="wordcount" role="status" style="margin-top: 3.5rem; font-size: 0.75rem;">
    <span style="{value > 64 ? 'color: #e24;' : ''}">{value}</span> / 64 words
</div>
